import { render, staticRenderFns } from "./VacancyDetailsItems.vue?vue&type=template&id=415005ec&scoped=true&"
import script from "./VacancyDetailsItems.vue?vue&type=script&lang=js&"
export * from "./VacancyDetailsItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415005ec",
  null
  
)

export default component.exports